import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMap"><Path d="M8.5 5V17.5M15.5 6.5V19M2.5 20V6.13333L8.5 4L15.5 6.13333L21.5 4V17.8667L15.5 20L8.5 17.8667L2.5 20Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMap;
